export default {"src":"/reise/pakkereiser/_next/static/media/sq.b5ad3f49.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};